const StatusBreakdown = ({ items, loading, empty = "Nothing to show yet." }) => {
  if (loading) {
    return (
      <div className="space-y-3">
        <div className="h-2 animate-pulse rounded-full bg-gray-100" />
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-3 animate-pulse rounded-full bg-gray-100" />
        ))}
      </div>
    );
  }

  const total = items.reduce((sum, item) => sum + item.count, 0);
  if (!total) return <p className="text-sm text-gray-400">{empty}</p>;

  const pct = (count) => (count / total) * 100;

  return (
    <div>
      <div className="flex h-2 gap-[2px] overflow-hidden rounded-full">
        {items.map((item) => (
          <span
            key={item.label}
            title={`${item.label}: ${item.count}`}
            style={{ width: `${pct(item.count)}%` }}
            className={`h-2 first:rounded-l-full last:rounded-r-full ${item.dot}`}
          />
        ))}
      </div>

      <ul className="mt-4 space-y-2.5">
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-3">
            <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${item.dot}`} />
            <span className="w-[7.5rem] shrink-0 truncate text-xs text-gray-600" title={item.label}>
              {item.label}
            </span>
            <span className="h-2 flex-1 rounded-full bg-gray-100">
              <span
                style={{ width: `${Math.max(pct(item.count), 3)}%` }}
                className={`block h-2 rounded-full ${item.dot}`}
              />
            </span>
            <span className="w-8 shrink-0 text-right text-xs font-semibold tabular-nums text-gray-900">
              {item.count}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StatusBreakdown;